import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import user from "./modules/user";
import areaTree from "./modules/areaTree";
import course from "./modules/course";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    user,
    areaTree,
    course
  },
  state: {},
  mutations: {},
  getters: {},
  actions: {},
  strict: debug,
  // 文档见 https://github.com/robinvdvleuten/vuex-persistedstate
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: "ai-official-yg"
    })
  ]
});
